import styled from "styled-components";

import { colors } from "../../../consts";
import { device } from "../../../services";

import {
  Button,
  FlexContainers,
  IconButton,
  Paragraph2,
  WrapperContainer
} from "../../../components";
import { TableWrapper } from "../../../components/Table/styled";

export const ContentOverflowWrapper = styled(FlexContainers.FlexRowStart)`
  ${(props) => props.gap && `gap: ${props.gap}px`};

  overflow-x: scroll;
  padding-bottom: 4px;
  margin-top: 8px;

  ::-webkit-scrollbar {
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    height: 4px;
  }
`;

export const TableFilersWrapper = styled(WrapperContainer)`
  @media screen and ${device.tablet} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SearchInputWrapper = styled(WrapperContainer)`
  @media screen and ${device.tablet} {
    max-width: unset !important;
  }
`;

export const TableFiltersRightWrapper = styled(WrapperContainer)`
  @media screen and ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StoresButton = styled(Button)`
  height: 48px;
  padding: 0 30px 0 20px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  gap: 10px;

  &:active {
    svg {
      path {
        fill: ${colors.ISABELLINE};
      }
    }
  }
`;

export const UsersTableWrapper = styled(WrapperContainer)`
  ${TableWrapper} {
    overflow: visible;
  }
`;

export const UserIconContainer = styled(WrapperContainer)`
  width: 40px;
  height: 40px;

  min-width: 40px;

  border-radius: 8px;
  background: ${colors.ISABELLINE_DARKER};
`;

export const FilterButton = styled(IconButton)`
  padding: 10px 14px;
  border: 2px solid ${colors.RAISIN_100};
  border-radius: 36px;
  ${(props) => props.active && `background-color: ${colors.ISABELLINE_DARKER};`}

  align-items: center;
  gap: 2px;
`;

export const FilterCounter = styled(Paragraph2)`
  line-height: 24px;
  font-weight: 600;
  background-color: ${colors.TURQUOISE_100};
  border-radius: 100%;

  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FilterSwitchButton = styled(FlexContainers.FlexRowStart)`
  padding: 8px 10px;

  font-weight: ${(props) => (props.active ? "500" : "400")};
  font-size: 16px;
  line-height: 24px;

  color: ${(props) => (props.active ? colors.RAISIN_100 : colors.RAISIN_80)};
  background-color: ${(props) => (props.active ? colors.RAISIN_20 : "transparent")};
  border: 1px solid ${(props) => (props.active ? colors.RAISIN_100 : colors.RAISIN_20)};

  cursor: pointer;

  &:hover {
    background-color: ${(props) => (props.active ? colors.RAISIN_20 : colors.ISABELLINE)};
    color: ${colors.RAISIN_100};
  }

  gap: 4px;
  border-radius: 8px;

  ${FilterCounter} {
    min-width: 20px;
    width: fit-content;

    font-size: 12px;

    padding: 4px;

    color: ${(props) => (props.active ? colors.WHITE : colors.RAISIN_80)};
    background-color: ${(props) => (props.active ? colors.RAISIN_80 : colors.RAISIN_20)};
    border-radius: 70px;

    &:hover {
      color: ${colors.RAISIN_100};
    }
  }
`;
